<template>
    <div
        class="virtual-select-list-item"
        :class="[theme, { selected: selected }]"
    >
        <span class="label">{{ label }}</span>
        <div class="icon">
            <slot name="default">
                <template v-if="!multiple">
                    <span class="item-icon iconfont icon-checked-light"></span>
                </template>
                <template v-else>
                    <Checkbox :theme="theme" :value="selected" />
                </template>
            </slot>
        </div>
    </div>
</template>
<script>
import Checkbox from '@/components/global/checkbox.vue';
export default {
    components: {
        Checkbox
    },
    props: {
        multiple: {
            type: Boolean,
            default: false
        },
        label: {
            type: String,
            default: ''
        },
        selected: {
            type: Boolean,
            default: false
        },
        theme: {
            type: String,
            defualt: 'standard'
        }
    }
};
</script>
<style lang="scss">
.virtual-select-list-item {
    height: 100%;
    &.selected {
        color: var(--g-btn-background) !important;
    }
    &:not(.selected) {
        .item-icon {
            display: none;
        }
    }
    display: flex;
    justify-content: center;
    align-items: center;
    .label {
        flex: 1;
        // display: flex;
        // align-items: center;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
    }
    .icon {
        display: flex;
        align-items: center;
        justify-content: center;
    }
}
.virtual-select-list-item {
    .comp-im-checkbox .label.standard .checkicon {
        color: var(--g-btn-background) !important;
    }
}
</style>
